import React from 'react'

const Contact = () => {
    return (
        <div className='w-full bg-[#2d4667] py-10 '>
            <div className='flex flex-col gap-5  max-w-5xl p-3 mx-auto'>
                <div className='flex items-center md:flex-row flex-col gap-5'>
                    <img src='https://cdn1.breatheagain.io/media/vsl/delivery-truck.webp' className='w-40' />
                    <div className='flex items-center flex-col justify-center gap-6'>
                        <p className='text-white md:text-4xl text-center text-2xl font-bold'>
                        Every <span className='underline'>6 Bottle</span> Order Gets <span className='underline'>FREE Shipping</span> Too!
                        </p>
                        <p className=' text-2xl text-white font-light text-center'>
                        *96% of customers order more than 6 bottles  <span className='text-[#85ADE1] font-semibold'>(Our recommended option)</span></p>
                    </div>
                </div>

            </div>
        </div >
    )
}
export default Contact
